import MainTable from "../components/MainTable";
import AddHabit from "../components/AddHabit";
import Header from "../components/Header";
import { useState, useEffect, useContext } from "react";
import AppContext from "../context/AppProvider";

function HomePage() {
  const { settings } = useContext(AppContext);
  const [habits, setHabits] = useState(
    JSON.parse(localStorage.getItem("habitlist")) || []
  );
  const [newHabit, setNewHabit] = useState("");

  useEffect(() => {
    localStorage.setItem("habitlist", JSON.stringify(habits));
  }, [habits]);

  const addHabit = (name) => {
    // true if items are in list, false if empty
    const id = habits.length ? habits[habits.length - 1].id + 1 : 1;

    // initialize a days array to capture button click state
    let daysInitial = [];
    for (let i = 1; i <= 31; i++) {
      daysInitial.push({
        day: i,
        color: "white",
      });
    }

    const myNewHabit = { id, name, days: daysInitial };
    const listHabits = [...habits, myNewHabit];
    setHabits(listHabits);
  };

  // Submitting a new habbit
  const handleSubmit = (e) => {
    // I need to handle the differences in ' from ios to other platforms. Seems to be a unicode error
    let indexPosition = 8;
    if (
      newHabit.trim().slice(0, indexPosition - 1) +
        newHabit.trim().slice(indexPosition) ==
      "Larissas secret"
    ) {
      alert("I love you, beautiful. 😘");
    } else {
      e.preventDefault();
      if (!newHabit) return;
      addHabit(newHabit);
      setNewHabit("");
    }
  };

  // Deleting a habit
  const handleDelete = (id) => {
    let confirmed = window.confirm(
      "Are you sure you want to delete this habbit?"
    );
    if (confirmed) {
      const habitlist = habits.filter((habit) => habit.id !== id);
      setHabits(habitlist);
    } else {
      return;
    }
  };

  const handleHabitRefresh = (habit) => {
    let confirmed = window.confirm(
      "Are you sure you want to refresh this habit?"
    );
    if (confirmed) {
      // initialize a days array to capture button click state
      let daysInitial = [];
      for (let i = 1; i <= 31; i++) {
        daysInitial.push({
          day: i,
          color: "white",
        });
      }
      const habitlist = habits.map((item) =>
        item.id === habit.id ? { ...item, days: daysInitial } : item
      );
      setHabits(habitlist);
    } else {
      return;
    }
  };

  //Handling a day click to log your habit
  const handleDayClick = (id, dayNumber) => {
    let habitlist = habits.map((habit) =>
      habit.id === id
        ? {
            ...habit,
            days: habit.days.map((day) =>
              day.day === dayNumber
                ? {
                    ...day,
                    color:
                      day.color === "white"
                        ? settings.color
                        : day.color === settings.color
                        ? "black"
                        : "white",
                  }
                : day
            ),
          }
        : habit
    );
    console.log(habits);
    console.log(habitlist);
    setHabits(habitlist);
  };

  return (
    <div className="App">
      <Header />
      <MainTable
        habits={habits}
        handleDelete={handleDelete}
        handleDayClick={handleDayClick}
        handleHabitRefresh={handleHabitRefresh}
      />
      <AddHabit
        newHabit={newHabit}
        setNewHabit={setNewHabit}
        handleSubmit={handleSubmit}
      />
    </div>
  );
}

export default HomePage;
